/**
 * Wrapper for window.location functions (facilitates sinon stubbing)
 */

export const reload = () => window.location.reload()



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/utils/location.js